import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import Tabs from '../common/tab/tabs';
import TabsHeader from '../common/tab/tabsHeader';
import TabsContent from '../common/tab/tabsContent';
import TabHeader from '../common/tab/tabHeader';
import TabContent from '../common/tab/tabContent';
import { init, create, update, getList, setPaginaAtual } from './dataEspecialActions';
import PermissaoUsuario from '../auth/permissao';

import List from './dataEspecialList';
import Form from './dataEspecialForm';
import SelectConfControlador from '../common/selectdb/selectConfControlador';
import SelectConfGrupoFisico from '../common/selectdb/selectConfGrupoFisico';

class DataEspecial extends Component {
  componentWillMount() {
    this.props.init();
    this.changeControlador = this.changeControlador.bind(this);
  }

  changeControlador() {
    this.props.getList();
    this.props.setPaginaAtual(0);
    this.props.init();
  }

  render() {
    return (
      <div>
        <div className="contentHeaderFilter top-filter data-especial-filter">
          <SelectConfGrupoFisico onChange={this.changeControlador} />
          <SelectConfControlador anel={false} onChange={this.changeControlador} />
        </div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadDataEspecial" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form onSubmit={this.props.update} readOnly={false} submitClass="primary" submitLabel="Salvar" />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update, getList, setPaginaAtual }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(DataEspecial);
